module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "movie-cover",
    class: _vm.more,
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClick,
      "&touchstart": function($event) {
        return _vm.onTouchStart.apply(null, arguments)
      },
      "&touchend": function($event) {
        return _vm.onTouchEnd.apply(null, arguments)
      },
      "&touchmove": function($event) {
        return _vm.onTouchEnd.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "bg",
    style: ({
      backgroundImage: 'url(' + _vm.value.pic + ')'
    })
  }), _vm._v(" "), _vm._t("default", function() {
    return [_c('div', [_vm._v(_vm._s(_vm.value.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.value.actor))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.value.director))]), _vm._v(" "), (_vm.more === 'add') ? _c('div', [_vm._v("发布日期\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("date")(_vm.value.addtime)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.more === 'update') ? _c('div', [_vm._v("更新日期\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("date")(_vm.value.modifytime)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.more === 'simple') ? _c('div', [_vm._v(_vm._s(_vm._f("date")(_vm.value.addtime)))]) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72cc1eeb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/MovieCover.vue
// module id = 334
// module chunks = 0